export default __webpack_public_path__ + "static/media/warning--disabled-persons-crossing--g2.1097238b.png";